import React, { useEffect } from "react";
import { UserContext } from "./context";
import Card from "./context";
import * as XLSX from 'xlsx/xlsx.mjs';
import { useTable, usePagination } from 'react-table'

export default function AllData(){
    const [actHist, setActHist] = React.useState([]);
    const { session, setSession } = React.useContext(UserContext);

    async function getHist() {
        const url = "/account/all";
        var response = await fetch(url,{ 
            headers: {
                'Authorization': 'Bearer '+ session.token, 
            },
        });
        var data = await response.json();
        const lst = data.filter(data => data.acct === session.account);
        setActHist(lst);
    }

    useEffect(() => {
        getHist();
    },[session]);

    function fixBal(item) {
        let newBal = item.toFixed(2);
          (newBal).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
          return newBal;
    }

    function cleanDt(item){
        let dt = item.split(/[+-]+/);
        return dt[0];
    }

    function exportXl() {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(actHist);
        XLSX.utils.book_append_sheet(wb,ws, "History");
        XLSX.writeFile(wb, "Account History.xlsx");
    }

      
    const columns = [
      {
        Header: 'Account #',
        accessor: 'acct'
      }, {
        Header: 'Name',
        accessor: 'name'
      }, {
        Header: 'Email',
        accessor: 'email'
      }, {
          Header: 'Action',
          accessor: 'Transaction'
        }, {
          Header: 'Balance',
          accessor: 'balance'
        }, {
          Header: 'Date/Time',
          accessor: 'date'
        }
      
    ]

    function Table({columns, data}) {
        const {
          page,
          getTableProps,
          getTableBodyProps,
          headerGroups,
          prepareRow,
          canPreviousPage,
          canNextPage,
          pageOptions,
          pageCount,
          gotoPage,
          nextPage,
          previousPage,
          setPageSize,
          state: { pageIndex, pageSize },
        } = useTable(
          {
            columns,
            data,
            initialState: { pageIndex: 0 },
          },
          usePagination
        )
      
        return (
          <>
            <div className="card">
              <div className="card-body">
                    <table className="table table-light" {...getTableProps()}>
                    <thead>
                      {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row, i) => {
                        prepareRow(row)
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {console.log(cell.getCellProps())
                              return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>  
      
                <div className="pagination">
                        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                          {'<<'}
                        </button>{' '}
                        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                          {'<'}
                        </button>{' '}
                        <button onClick={() => nextPage()} disabled={!canNextPage}>
                          {'>'}
                        </button>{' '}
                        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                          {'>>'}
                        </button>{' '}
                        <span>
                          Page{' '}
                          <strong>
                            {pageIndex + 1} of {pageOptions.length}
                          </strong>{' '}
                        </span>
                        <span>
                          | Go to page:{' '}
                          <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={e => {
                              const page = e.target.value ? Number(e.target.value) - 1 : 0
                              gotoPage(page)
                            }}
                            style={{ width: '100px' }}
                          />
                        </span>{' '}
                        <select
                          value={pageSize}
                          onChange={e => {
                            setPageSize(Number(e.target.value))
                          }}
                        >
                          {[3, 7, 15].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                              Show {pageSize}
                            </option>
                          ))}
                        </select>
                    </div>
                  </div>
            </div>
          </>
      
        )
      }
      

      
        
    return (
        <Card 
            
            style={{width: "auto"}}
            txtcolor = "success"
            bgcolor= "light"
            header= {session.auth === true ? (
                    <>
                        <span>Account History for acct# {session.account}</span><button className="btn btn-dark" style={{ color: "white", display: 'flex', alignItems: 'flex-end', float: 'right', borderRadius: "10px", padding: "7px", backgroundColor: "#04AA6D", fontSize: "15px" }} onClick={exportXl}>Export</button>
                    </>) : (
                        <span>Account History</span>
                    )}
            body={session.auth === true ? (
            <>
                <Table data={actHist} columns={columns}/>
            </>
            ) : (
                <div>
                    Please Login in to View Account History
                </div>
            )}
        />
    )
}